// DO NOT EDIT -- generated from fs/services/dx-objects/annotations.proto

import { ObjectType } from './modeltypes.proto';
import * as accesscontrol from '../../shared/accesscontrol';
import * as protobuf from '../../../google/protobuf';

/** Internal service for cog to cog communication */
export namespace AnnotationsInternal {

  export const DeleteTrailingEdgeAnnotationsForOrgEndpoint = "/grpc/dx_objects.AnnotationsInternal/DeleteTrailingEdgeAnnotationsForOrg";
  /** Used for "trailing edge" deletions (i.e. falls out of retention window) */
  export function DeleteTrailingEdgeAnnotationsForOrg(sender: (req: DeleteTrailingEdgeObjectForOrgRequest, endpoint: string) => Promise<DeleteAnnotationsForOrgResponse>, req: DeleteTrailingEdgeObjectForOrgRequest): { promise: () => Promise<DeleteAnnotationsForOrgResponse>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteTrailingEdgeAnnotationsForOrgEndpoint),
      endpoint: DeleteTrailingEdgeAnnotationsForOrgEndpoint
    };
  }

  export const DeleteAllAnnotationsForOrgEndpoint = "/grpc/dx_objects.AnnotationsInternal/DeleteAllAnnotationsForOrg";
  /** Used when we delete an entire org */
  export function DeleteAllAnnotationsForOrg(sender: (req: DeleteAllAnnotationsForOrgRequest, endpoint: string) => Promise<DeleteAnnotationsForOrgResponse>, req: DeleteAllAnnotationsForOrgRequest): { promise: () => Promise<DeleteAnnotationsForOrgResponse>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteAllAnnotationsForOrgEndpoint),
      endpoint: DeleteAllAnnotationsForOrgEndpoint
    };
  }

  export const GetAllAnnotationsEndpoint = "/grpc/dx_objects.AnnotationsInternal/GetAllAnnotations";
  export function GetAllAnnotations(sender: (req: GetAllAnnotationsRequest, endpoint: string) => Promise<GetAllAnnotationsResponse>, req: GetAllAnnotationsRequest): { promise: () => Promise<GetAllAnnotationsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllAnnotationsEndpoint),
      endpoint: GetAllAnnotationsEndpoint
    };
  }
}

/** Public service for annotations operations */
export namespace AnnotationsPublic {

  export const CreateAnnotationEndpoint = "/grpc/dx_objects.AnnotationsPublic/CreateAnnotation";
  export function CreateAnnotation(sender: (req: CreateAnnotationRequest, endpoint: string) => Promise<CreateAnnotationResponse>, req: CreateAnnotationRequest): { promise: () => Promise<CreateAnnotationResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateAnnotationEndpoint),
      endpoint: CreateAnnotationEndpoint
    };
  }

  export const UpdateAnnotationEndpoint = "/grpc/dx_objects.AnnotationsPublic/UpdateAnnotation";
  export function UpdateAnnotation(sender: (req: UpdateAnnotationRequest, endpoint: string) => Promise<UpdateAnnotationResponse>, req: UpdateAnnotationRequest): { promise: () => Promise<UpdateAnnotationResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateAnnotationEndpoint),
      endpoint: UpdateAnnotationEndpoint
    };
  }

  export const DeleteAnnotationAndAssociationEndpoint = "/grpc/dx_objects.AnnotationsPublic/DeleteAnnotationAndAssociation";
  export function DeleteAnnotationAndAssociation(sender: (req: DeleteAnnotationAndAssociationRequest, endpoint: string) => Promise<{}>, req: DeleteAnnotationAndAssociationRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteAnnotationAndAssociationEndpoint),
      endpoint: DeleteAnnotationAndAssociationEndpoint
    };
  }

  export const BulkDeleteAnnotationsEndpoint = "/grpc/dx_objects.AnnotationsPublic/BulkDeleteAnnotations";
  /**
   * BulkDeleteAnnotations deletes a list of annotations by ID. If the user does not have permission to delete any one
   * of the supplied annotation IDs, then a PermissionDenied will be returned and no annotations will be deleted.
   */
  export function BulkDeleteAnnotations(sender: (req: BulkDeleteAnnotationsRequest, endpoint: string) => Promise<{}>, req: BulkDeleteAnnotationsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, BulkDeleteAnnotationsEndpoint),
      endpoint: BulkDeleteAnnotationsEndpoint
    };
  }

  export const GetAnnotationsAccessEndpoint = "/grpc/dx_objects.AnnotationsPublic/GetAnnotationsAccess";
  export function GetAnnotationsAccess(sender: (req: accesscontrol.CanAccessRequest, endpoint: string) => Promise<accesscontrol.CanAccessResponse>, req: accesscontrol.CanAccessRequest): { promise: () => Promise<accesscontrol.CanAccessResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAnnotationsAccessEndpoint),
      endpoint: GetAnnotationsAccessEndpoint
    };
  }

  export const GetAnnotationsForDxObjectEndpoint = "/grpc/dx_objects.AnnotationsPublic/GetAnnotationsForDxObject";
  export function GetAnnotationsForDxObject(sender: (req: GetAnnotationsForDxObjectRequest, endpoint: string) => Promise<GetAnnotationsForDxObjectResponse>, req: GetAnnotationsForDxObjectRequest): { promise: () => Promise<GetAnnotationsForDxObjectResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAnnotationsForDxObjectEndpoint),
      endpoint: GetAnnotationsForDxObjectEndpoint
    };
  }

  export const GetGlobalAnnotationsEndpoint = "/grpc/dx_objects.AnnotationsPublic/GetGlobalAnnotations";
  export function GetGlobalAnnotations(sender: (req: GetAllAnnotationsRequest, endpoint: string) => Promise<GetGlobalAnnotationsResponse>, req: GetAllAnnotationsRequest): { promise: () => Promise<GetGlobalAnnotationsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetGlobalAnnotationsEndpoint),
      endpoint: GetGlobalAnnotationsEndpoint
    };
  }
}

/** AnnotationsAppBackendPublic implements backend-for-frontend APIs for serving Annotations views in the app */
export namespace AnnotationsAppBackendPublic {

  export const GetAnnotationsListViewEndpoint = "/grpc/dx_objects.AnnotationsAppBackendPublic/GetAnnotationsListView";
  export function GetAnnotationsListView(sender: (req: GetAnnotationsListViewRequest, endpoint: string) => Promise<GetAnnotationsListViewResponse>, req: GetAnnotationsListViewRequest): { promise: () => Promise<GetAnnotationsListViewResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAnnotationsListViewEndpoint),
      endpoint: GetAnnotationsListViewEndpoint
    };
  }
}

export interface AuditMetadata {
  createdBy: string;
  createdByUser: AuditUser | null;
  createdAt: protobuf.timestamp | null;
  updatedBy: string;
  updatedAt: protobuf.timestamp | null;
}

export interface AuditUser {
  /** This field should always be set in the return object */
  email: string;
  /** Name fields are not guaranteed to be set, but will fall back to empty string if missing */
  firstName: string;
  lastName: string;
}

export interface AnnotationAssociation {
  dxObjectId: string;
  dxObjectType: ObjectType;
}

export interface Annotation {
  id: string;
  startTime: protobuf.timestamp | null;
  duration: protobuf.duration | null;
  /** Typically a single character emoji string */
  label: string;
  /** The text explaining the annotation */
  description: string;
  apiCreated: boolean;
  apiSource: string;
  association?: AnnotationAssociation | null;
  global?: boolean;
  metadata: AuditMetadata | null;
}

export namespace Annotation {
  export enum scope {
    association = 6,
    global = 10
  }

  export function scope_oneof(m: Annotation): { opt: scope.association, val: AnnotationAssociation } | { opt: scope.global, val: boolean } | null {
    if (m.association != null) { return { opt: scope.association, val: m.association } }
    if (m.global != null) { return { opt: scope.global, val: m.global } }
    return null;
  }
}

export interface CreateAnnotationRequest {
  orgId: string;
  /**
   * Deprecated in favor of association
   * 
   * @deprecated
   */
  dxObjectId: string;
  /**
   * Deprecated in favor of association
   * 
   * @deprecated
   */
  dxObjectType: ObjectType;
  startTime: protobuf.timestamp | null;
  duration: protobuf.duration | null;
  /** Typically a single character emoji string */
  label: string;
  /** The text explaining the annotation */
  description: string;
  association?: AnnotationAssociation | null;
  global?: boolean;
}

export namespace CreateAnnotationRequest {
  /** The scope of the annotation to create */
  export enum scope {
    association = 8,
    global = 9
  }

  /** The scope of the annotation to create */
  export function scope_oneof(m: CreateAnnotationRequest): { opt: scope.association, val: AnnotationAssociation } | { opt: scope.global, val: boolean } | null {
    if (m.association != null) { return { opt: scope.association, val: m.association } }
    if (m.global != null) { return { opt: scope.global, val: m.global } }
    return null;
  }
}

export interface UpdateAnnotationRequest {
  orgId: string;
  id: string;
  startTime: protobuf.timestamp | null;
  duration: protobuf.duration | null;
  /** Typically a single character emoji string */
  label: string;
  /** The text explaining the annotation */
  description: string;
  association?: AnnotationAssociation | null;
  global?: boolean;
}

export namespace UpdateAnnotationRequest {
  export enum scope {
    association = 7,
    global = 8
  }

  export function scope_oneof(m: UpdateAnnotationRequest): { opt: scope.association, val: AnnotationAssociation } | { opt: scope.global, val: boolean } | null {
    if (m.association != null) { return { opt: scope.association, val: m.association } }
    if (m.global != null) { return { opt: scope.global, val: m.global } }
    return null;
  }
}

export interface UpdateAnnotationResponse {
  annotation: Annotation | null;
}

export interface CreateAnnotationResponse {
  annotation: Annotation | null;
}

export interface DeleteTrailingEdgeObjectForOrgRequest {
  orgId: string;
  beforeTime: protobuf.timestamp | null;
}

export interface DeleteAllAnnotationsForOrgRequest {
  orgId: string;
}

export interface DeleteAnnotationsForOrgResponse {
  annotationDeleteCount: protobuf.int64;
}

export interface DeleteAnnotationAndAssociationRequest {
  orgId: string;
  id: string;
}

export interface BulkDeleteAnnotationsRequest {
  orgId: string;
  ids: string[];
}

export interface GetAllAnnotationsRequest {
  orgId: string;
}

export interface GetAllAnnotationsResponse {
  annotations: Annotation[];
}

export interface GetGlobalAnnotationsRequest {
  orgId: string;
}

export interface GetGlobalAnnotationsResponse {
  annotations: Annotation[];
}

export interface GetAnnotationsForDxObjectRequest {
  orgId: string;
  dxObjectId: string;
  dxObjectType: ObjectType;
}

export interface GetAnnotationsForDxObjectResponse {
  annotations: Annotation[];
}

export interface GetAnnotationsListViewRequest {
  orgId: string;
}

export interface GetAnnotationsListViewResponse {
  annotationListItems: AnnotationListItem[];
}

export interface AnnotationListItem {
  annotation: Annotation | null;
  /** the name of the metric or funnel associated with the annotation, this is empty for global annotations */
  dxObjectName: string;
}
